<template>
  <div class="mb-32 md:mb-56">
    <Breadcrumb
      :current-page-title="breadcrumb.currentPageTitle"
      data-test="article-breadcrumb"
      :intermediary-path="breadcrumb.intermediaryPath"
    />
  </div>
</template>

<script lang="ts" setup>
import { useCMSHead } from '../../cms/composables/useCMSHead'
import Breadcrumb from '../../cms/shared-components/Breadcrumb/Breadcrumb.vue'

import { useFetchArticle } from './composables/useFetchArticle'
import { useGetBreadcrumb } from './composables/useGetBreadcrumb'
import { useHandleArticleFetchErrors } from './composables/useHandleFetchErrors'
import { useHandleIncorrectRouteParams } from './composables/useHandleIncorrectRouteParams'

const { fetchedContent, fetchedVotes } = await useFetchArticle()
const { data: content, error: contentErrorRef } = fetchedContent
const { error: votesErrorRef } = fetchedVotes

useHandleArticleFetchErrors({ contentErrorRef, votesErrorRef })
useHandleIncorrectRouteParams(content)
useCMSHead(content)

const breadcrumb = useGetBreadcrumb(content)
</script>
